import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const financeReportingPlugin = createPlugin({
  id: 'finance-reporting',
  routes: {
    root: rootRouteRef,
  },
});

export const FinanceReportingPage = financeReportingPlugin.provide(
  createRoutableExtension({
    name: 'FinanceReportingPage',
    component: () =>
      import('./components/FinanceReportingPage').then(
        m => m.FinanceReportingPage,
      ),
    mountPoint: rootRouteRef,
  }),
);
